export const MarginField = ({
    disabled,
    readonly,
    style,
    value,
    onValueChanged,
  }: {
    disabled?: boolean,
    readonly?: boolean;
    style?: string;
    value: string;
    onValueChanged?: (value: string) => void;
  }) => {
    const s = readonly ? "addProductReadonlyField" : "addProductField";
  
    return (
      <input
        className={`${s} ${style} text-right`}
        disabled={disabled}
        readOnly={readonly}
        value={value}
        type="text"
        onChange={(e) => {
          if (onValueChanged) {
            onValueChanged(e.currentTarget.value);
          }
        }}
      />
    );
  };
  